import {listWebActivityLogs, exportWebActivityLogs} from "@/services/api/common/report";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  list: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'startTime',
  },
});

export default {
  namespaced: true,

  actions: {
    list({commit, state}, data) {
      return listWebActivityLogs({
        ...data,
        pagination: state.pagination
      })
        .then(({result, pagination}) => {
          commit('setLogs', result)
          commit('setPagination', pagination)
        })
    },
    export({commit, state}, data) {
      return exportWebActivityLogs(data)
    },
  },

  mutations: {
    setLogs(state, webActivityLogs) {
      state.list = webActivityLogs.map(webActivityLog => ({
        ...webActivityLog,
        provider: 5
      }));
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'startTime',
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  getters: {},

  state: defaultState,

  modules: {},

}
